const config = {
  smallIcon: {
    measures: {
      width: '32',
      height: '32',
    },
  },
  mediumIcon: {
    measures: {
      width: '48',
      height: '48',
    },
  },
  largeIcon: {
    measures: {
      width: '56',
      height: '56',
    },
    configBuilderMeasures: {
      imgWidth: 56,
      imgHeight: 56,
    },
  },
};

export default config;
